export default __webpack_public_path__ + "static/media/active-more-horiz.6bca1f5b.svg";